import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'no_fire_extinguisher_provided_facility_when_hot_works'

export const dataPointDefinition = {
  retracedId: 'no_fire_extinguisher_provided_facility_when_hot_works',
  name: 'No fire extinguisher is provided by the facility when hot works are performed (i.e. if the contractor did not bring thei',
  description: '',
  meta: {
    slcpMeta: {
      key: 'hs-con-8x',
      number: 'HS-CON-2-6',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-con-2',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],hs-54,Yes',
      machineShowHide: '[2],hs-54,1',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-con-8x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 30570,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
